import url from '../../../../url.js';
export default {
    data() {
        return {
            title: [
                {
                first: 'Fastana Warehouse',
                second: 'Indonesia',
                img: 'assets/gudang/1.webp',
                desc: 'Lokasi Warehouse yang tersebar di seluruh Indonesia'
                },
                {
                first: 'Solusi Pergudangan',
                second: 'Indonesia',
                img: 'assets/gudang/2.webp',
                desc: 'Menyajikan solusi yang terintegrasi untuk kebutuhan bisnis Anda'
                },
                {
                first: 'Manajemen Stok',
                second: 'Terintegrasi',
                img: 'assets/gudang/1.webp',
                desc: 'Mengelola Stok produk secara efektif dan efisien'
                },
                {
                first: 'Automatic System',
                img: 'assets/gudang/2.webp',
                desc: 'Menggunakan sistem yang canggih dan terintegrasi untuk memudahkan pengelolaan'
                },
            ],
            dataLayanan: [],
            button: 'Lokasi Gudang',
            ApiUrl: url.API_URL,
            api: url.URL,
            image: url.IMAGE + 'dc/',
            produkList: [],
        }
    },
    methods: {
        async fetchData() {
            const response = await fetch(`${this.ApiUrl}m139_operasionals/id/2`);
            const data = await response.json();
            this.dataLayanan = data;
        },
        async fetchProduct() {
        try {
            const response = await fetch(`${this.ApiUrl}m154_gudang/id/2`);

            const text = await response.text();
            let data;
            try {
                data = JSON.parse(text);
            } catch (parseError) {
                console.error('JSON parsing error:', parseError);
                return;
            }

            this.produkList = data;
            console.log(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        },
    },
    mounted(){
        this.fetchData();
        this.fetchProduct();
    }
}